<div class="mt-4">
  <h1>
    What!!?? Inconceivable.
  </h1>
  <h3>
    Something wrong has happend. Sorry mate!
  </h3>
</div>
